<template>
    <v-stepper-header style="position:sticky;top:0;background-color:white;z-index:1000;">
        <v-stepper-step
            editable
            :step="1"
            :rules="[ () => validations.step1 ]"
            @click="() => onClick_StepperHeader('1')">
            Slot Config
        </v-stepper-step>

        <v-divider />
        <v-stepper-step
            editable
            :step="2"
            :rules="[ () => validations.step2 ]"
            @click="() => onClick_StepperHeader('2')">
            Slot Period
        </v-stepper-step>
    </v-stepper-header>
</template>

<script>

    export default {
        name: 'StepperHeader',


        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'update', 'create', 'extend'
            validations: Object, // Info about a specific step: is valid or not
            onClick_StepperHeader: Function

        }, // eo props{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Listeners
            *******************************************************************/
            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc:
            * Note:
            *
            */
            // onClick_StepperHeader: function(stepperNumber) {

            //     const me = this;


			// 	me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/StepperHeader.vue >>> onClick_StepperHeader');
            //     me.$emit('change', stepperNumber);

            // } // eo function onClick_StepperHeader()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

    .sdr-custom-tab-active {
        color: #AB3B7A !important;
    }

    .sdr-custom-tabs .v-item-group {
        padding-left: 0;
    }

</style>
